module.exports = __webpack_public_path__ + "img/banner.30c444e4.png";